import apiFetch from '../apiFetch'

export default function (fuelId, token) {
  return apiFetch({ endPoint: `Fuel/${fuelId}/Recover`, method: 'PUT', token: token })
}
